import Link from "next/link";

const Footer = ({ darkTheme }: any) => {
  const footerText = {
    equities: [
      { name: "Trending strategies on Microsoft", symbol: "MSFT" },
      { name: "Trending strategies on Robinhood", symbol: "HOOD" },
      { name: "Trending strategies on Netflix", symbol: "NFLX" },
      { name: "Trending strategies on Apple", symbol: "AAPL" },
      { name: "Long Strategies on Nvidia", symbol: "NVDA" },
      { name: "Short Strategies on AMD", symbol: "AMD" },
    ],
    crypto: [
      { name: "Trending strategies on Bitcoin", symbol: "BTC-USDT" },
      { name: "Trending strategies on Solana", symbol: "SOL-USDT" },
      { name: "Trending strategies on Dogecoin", symbol: "DOGE-USDT" },
      { name: "Trending strategies on Polkadot", symbol: "DOT-USDT" },
      { name: "Long Strategies on PEPE meme coin", symbol: "PEPE-USDT" },
      { name: "Short Strategies on Ethereum", symbol: "ETH-USDT" },
    ],
    forex: [
      { name: "British Pound / Japanese Yen", symbol: "C:GBPJPY" },
      { name: "U.S. Dollar / Swiss Franc", symbol: "C:USDCHF" },
      { name: "Euro / U.S. Dollar", symbol: "C:EURUSD" },
      { name: "U.S. Dollar / Japanese Yen", symbol: "C:USDJPY" },
      { name: "Gold (XAU/USD)", symbol: "C:XAUUSD" },
      { name: "Euro / British Pound", symbol: "C:EURGBP" },
    ],
  };

  return (
    <footer className="pb-10 pt-8 w-full">
      <div className="ml-5 mr-5">
        <div className="mt-8 border-t border-2 mb-10"></div>

        <div className="lg:flex w-full justify-center">
          {/* Logo Section */}
          <div>
            <a href="https://www.trylevel2.com">
              <div className="lg:mr-20 mb-10 lg:mb-0">
                {darkTheme ? (
                  <img
                    src="/images/logos/Logo_Dark.png"
                    className="md:max-h-[35px] xs:max-h-[25px] max-h-[25px] sm:max-w-[300px]"
                    alt=""
                  />
                ) : (
                  <img
                    src="/images/logos/Logo_Light-2.png"
                    className="md:max-h-[30px] xs:max-h-[25px] max-h-[25px] sm:max-w-[300px]"
                    alt=""
                  />
                )}
                <p className="text-xs  mt-2">Intelligent Automation</p>
              </div>
            </a>
          </div>
          <div>
            <div className="font-semibold mb-4 text-xl">Top Trending</div>
            <div className="sm:flex gap:10 md:gap-10  lg:gap-20">
              {/* Equities Section */}
              <div className="mb-6 sm:mb-0">
                <h3 className="text-sm font-bold mb-4 text-muted-foreground">
                  Equities
                </h3>
                <ul className="space-y-2 text-sm">
                  {footerText.equities.map((item, index) => (
                    <li key={index}>
                      <Link
                        href={`/marketplace/${item.symbol}`}
                        className="hover:underline"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Crypto Section */}
              <div className="mb-6 sm:mb-0">
                <h3 className="text-sm font-bold mb-4 text-muted-foreground">
                  Crypto
                </h3>
                <ul className="space-y-2 text-sm">
                  {footerText.crypto.map((item, index) => (
                    <li key={index}>
                      <Link
                        href={`/marketplace/${item.symbol}`}
                        className="hover:underline"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Forex Section */}
              <div>
                <h3 className="text-sm font-bold mb-4 text-muted-foreground">
                  Forex
                </h3>
                <ul className="space-y-2 text-sm">
                  {footerText.forex.map((item, index) => (
                    <li key={index}>
                      <Link
                        href={`/marketplace/${item.symbol}`}
                        className="hover:underline"
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="mt-8 border-t border-1 text-[#545454] ml-[20%] mr-[20%]"></div>
        <div className="text-center text-muted-foreground text-xs mt-6">
          Need support? Email us at{" "}
          <a href="mailto:contact@trylevel2.com" className="hover:underline">
            contact@trylevel2.com
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
